const RouteEnum = {
    HOME: "/",
    ADVISORS: "/advisors",
    SHOWS: "/shows",

    BRUNELLO: "/brunello",
    BRUNELLO_SHOWS: "/brunello/shows",
    BRUNELLO_ADVISORS: "/brunello/advisors",

    SWATCH: "/swatch",
    SWATCH_SHOWS: "/swatch/shows",
    SWATCH_ADVISORS: "/swatch/advisors",

    SWATCH_ITALY: "/swatch-italy",
    SWATCH_ITALY_SHOWS: "/swatch-italy/shows",
    SWATCH_ITALY_ADVISORS: "/swatch-italy/advisors",

    SWATCH_SWITZERLAND: "/swatch-switzerland",
    SWATCH_SWITZERLAND_SHOWS: "/swatch-switzerland/shows",
    SWATCH_SWITZERLAND_ADVISORS: "/swatch-switzerland/advisors",

    BUNNINGS: "/bunnings",
    BUNNINGS_SHOWS: "/bunnings/shows",
    BUNNINGS_ADVISORS: "/bunnings/advisors",

    BENTLEY_UNIVERSITY: "/bentley-university",
    BENTLEY_UNIVERSITY_SHOWS: "/bentley-university/shows",
    BENTLEY_UNIVERSITY_ADVISORS: "/bentley-university/advisors",

    DEMO: "/demo",
    DEMO_SHOWS: "/demo/shows",
    DEMO_ADVISORS: "/demo/advisors",
}

export default RouteEnum;